export const googleSSO = {
  ContinueWithGoogle: "Continue with Google",
  ContinueWithGoogleInBrowser: "Continue with Google by opening this page in your default browser",
  Or: "Or",
} as const;
